import { AddOnFeature } from "./components/add-on-feature";

export default function AddOns() {
  return (
    <main className="mx-auto max-w-6xl px-2 py-20 md:px-5 md:py-12 sm:px-4 sm:py-8">
      <header className="mb-16 text-center md:mb-10 sm:mb-6">
        <h1 className="text-5xl font-semibold tracking-tight text-[#0C0C0C] md:text-3xl sm:text-2xl">
          Add-on Features
        </h1>
      </header>

      <div className="flex flex-col gap-16 md:gap-10 sm:gap-8">
        <AddOnFeature
          title={"AI-Based School Management"}
          description={
            <>
              <p>
                Transform school operations with an all‑in‑one AI platform featuring 25+ modules and a comprehensive
                dashboard. Manage academics, communication, and operations seamlessly—keeping everyone informed in real
                time.
              </p>
              <p className="mt-3">
                Available on iOS and Android, all apps are integrated for smarter management, faster decision‑making,
                and improved parent engagement.
              </p>
            </>
          }
          imageAlt="Phone UI demonstrating school management features on a soft blue background"
          imageQuery="images/new-landing-page/addOnFirstImage.svg"
        />

        <AddOnFeature
          reverse
          title="WhatsApp Automation"
          description={
            <>
              <p>
                Engage parents instantly with personalised messages, reminders, and automated follow‑ups. Reduce manual
                work and scale communication across your community.
              </p>
              <p className="mt-3">Drive better engagement with an integrated, intelligent solution.</p>
            </>
          }
          imageAlt="WhatsApp icon connected to nodes on a blue network background"
          imageQuery="images/new-landing-page/addOnSecondImage.svg"
        />

        <AddOnFeature
          title="AI‑Based ID Card"
          description={
            <>
              <p>
                Simplify and enhance student ID card creation with AI. Improve image quality, adjust lighting, and
                standardize backgrounds to deliver professional, high‑quality ID cards in seconds.
              </p>
            </>
          }
          imageAlt="Student ID card on soft glassy light-blue background"
          imageQuery="images/new-landing-page/addOnThirdImage.svg"
        />
      </div>
    </main>
  )
}